module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("日常辅助")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("消息模板")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "模板名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "模糊搜素",
      "name": "params"
    },
    model: {
      value: (_vm.queryParam.params),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "params", $$v)
      },
      expression: "queryParam.params"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.showAddModal
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/activity/message-template",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "operator": ""
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新增消息模板",
      "mask-closable": false,
      "width": 600
    },
    on: {
      "on-ok": _vm.handleAddConfirm,
      "on-cancel": function($event) {
        _vm.addModalVisible = false
      }
    },
    model: {
      value: (_vm.addModalVisible),
      callback: function($$v) {
        _vm.addModalVisible = $$v
      },
      expression: "addModalVisible"
    }
  }, [_c('Form', {
    ref: "addTemplateForm",
    attrs: {
      "model": _vm.newTemplate,
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "模板名称:",
      "prop": "templateName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入模板名称"
    },
    model: {
      value: (_vm.newTemplate.templateName),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "templateName", $$v)
      },
      expression: "newTemplate.templateName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "标题:",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.newTemplate.title),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "title", $$v)
      },
      expression: "newTemplate.title"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "模板内容:",
      "prop": "sendContent"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入模板内容"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.newTemplate.sendContent),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "sendContent", $$v)
      },
      expression: "newTemplate.sendContent"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "消息类型:",
      "prop": "msgType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择消息类型"
    },
    model: {
      value: (_vm.newTemplate.msgType),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "msgType", $$v)
      },
      expression: "newTemplate.msgType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "DING"
    }
  }, [_vm._v("钉钉消息")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SMS"
    }
  }, [_vm._v("短信")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "EMAIL"
    }
  }, [_vm._v("邮件")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CALL"
    }
  }, [_vm._v("电话")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PUSH"
    }
  }, [_vm._v("推送")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "COMMON_WEB_HOOK"
    }
  }, [_vm._v("通用webhook")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "接收人:",
      "prop": "sendTo"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择接收人"
    },
    model: {
      value: (_vm.newTemplate.sendTo),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "sendTo", $$v)
      },
      expression: "newTemplate.sendTo"
    }
  }, [_c('Option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("无身份")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TCH"
    }
  }, [_vm._v("老师")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "STUDENT"
    }
  }, [_vm._v("学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ADMIN"
    }
  }, [_vm._v("员工")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "WEB_HOOK"
    }
  }, [_vm._v("群机器人通知")])], 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "AppId:",
      "prop": "dingAppId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入AppId"
    },
    model: {
      value: (_vm.newTemplate.dingAppId),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "dingAppId", $$v)
      },
      expression: "newTemplate.dingAppId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "Secret:",
      "prop": "dingSecret"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入Secret"
    },
    model: {
      value: (_vm.newTemplate.dingSecret),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "dingSecret", $$v)
      },
      expression: "newTemplate.dingSecret"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "WebHook:",
      "prop": "hookUrl"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入WebHook地址"
    },
    model: {
      value: (_vm.newTemplate.hookUrl),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "hookUrl", $$v)
      },
      expression: "newTemplate.hookUrl"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态:",
      "prop": "enabled"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.newTemplate.enabled),
      callback: function($$v) {
        _vm.$set(_vm.newTemplate, "enabled", $$v)
      },
      expression: "newTemplate.enabled"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("正常")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("禁用")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0eda524","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/MessageTemplate.vue
// module id = 1937
// module chunks = 8